/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { ButtonHTMLAttributes, FC } from 'react'
import { rpMediaQueries } from '../../core/theme'
import { AcceptIcon, RejectIcon } from '../Icons'
import { Typography } from '../Typography'

interface DecisionBtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: 'accept' | 'reject'
  text: string
}

const iconSize = {
  mobile: '9px',
  tablet: '14px',
  desktop: '16px',
}

const DecisionBtn: FC<DecisionBtnProps> = ({ text, variant, ...rest }) => {
  const accept = css`
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: #16b154;
  `
  const reject = css`
    border: 1px solid rgba(255, 255, 255, 0.07);
    background: #b1161c;
  `
  const acceptHover = css`
    &:hover:not(:disabled) {
      background: #1dd166;
      border-color: rgba(255, 255, 255, 0.15);
      box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05), 0 4px 4px 0 rgba(0, 0, 0, 0.05),
        0 10px 10px 0 rgba(0, 0, 0, 0.1), 0 0 12px 0 rgba(22, 177, 84, 0.5);
    }
  `
  const rejectHover = css`
    &:hover:not(:disabled) {
      background: #d41920;
      border-color: rgba(255, 255, 255, 0.15);
      box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05), 0 4px 4px 0 rgba(0, 0, 0, 0.05),
        0 10px 10px 0 rgba(0, 0, 0, 0.1), 0 0 12px 0 rgba(177, 22, 28, 0.5);
    }
  `
  return (
    <button
      {...rest}
      type="button"
      css={css`
        all: unset;
        box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05),
          0 4px 4px 0 rgba(0, 0, 0, 0.05), 0 10px 10px 0 rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(10px);
        border-radius: 99px;
        padding: 6px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        ${variant === 'accept' && accept}
        ${variant === 'reject' && reject}
        ${variant === 'accept' && acceptHover}
        ${variant === 'reject' && rejectHover}
        cursor: pointer;
        transition: all 0.2s ease-in-out;

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        ${rpMediaQueries.tablet} {
          padding: 14px 18px;
          gap: 6px;
        }

        ${rpMediaQueries.desktop} {
          padding: 16px 18px;
        }
      `}>
      {variant === 'reject' && <RejectIcon color="white" size={iconSize} />}
      {variant === 'accept' && <AcceptIcon color="white" size={iconSize} />}
      <Typography variant="decisionBtn" color="white" as="div">
        {text}
      </Typography>
    </button>
  )
}

export default DecisionBtn
